import { format as dfFormat } from "date-fns";
import { enUS, el } from "date-fns/locale";
import { useTranslation } from "react-i18next";

const localeMap = { en: enUS, el };

/**
 * Locale-aware date formatter. Wraps date-fns `format()` picking a locale
 * based on the provided language string.
 */
export function formatDate(date, pattern = "PPP", lang = "en") {
  if (!date) return "";
  const d = typeof date === "string" ? new Date(date) : date;
  if (isNaN(d.getTime())) return "";
  const locale = localeMap[lang] || enUS;
  try {
    return dfFormat(d, pattern, { locale });
  } catch {
    return dfFormat(d, pattern);
  }
}

/**
 * React hook returning a `format(date, pattern)` function wired to the current i18n language.
 */
export function useFormatDate() {
  const { i18n } = useTranslation();
  const lang = i18n.language || "en";
  return (date, pattern = "PPP") => formatDate(date, pattern, lang);
}
